import { c as _c } from "react/compiler-runtime";
import { type ChangeEvent, useMemo } from 'react';
import { Select, type SelectOptionGroup } from '@/app/components/forms/select';
import { baseGridClassName, hideLastItemInGridClassName } from '@/app/lcv/components/sections/compare/styles';
import type { LcvCompareDataType } from '@/app/lcv/components/sections/compare/types';
import { cn } from '@/app/utils/cn';
import { safeCall } from '@/app/utils/safeCall';
export interface CompareSelectsProps {
  values: string[];
  optionGroups: LcvCompareDataType['optionGroups'];
  isMobile: boolean;
  onSelectOption: (index: number, value: string) => void;
}
export const CompareSelects = t0 => {
  const $ = _c(19);
  const {
    values: t1,
    optionGroups,
    onSelectOption
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const values = t2;
  let t3;
  if ($[2] !== optionGroups || $[3] !== values) {
    let t4;
    if ($[5] !== values) {
      t4 = item => ({
        ...item,
        options: item.options.map(model => ({
          ...model,
          disabled: values.includes(model.value)
        }))
      });
      $[5] = values;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    t3 = optionGroups.map(t4);
    $[2] = optionGroups;
    $[3] = values;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const options = t3;
  let t4;
  if ($[7] !== onSelectOption) {
    t4 = (e, index) => {
      if (!e?.target) {
        return;
      }
      safeCall(onSelectOption, index, e?.target?.value);
    };
    $[7] = onSelectOption;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleOnChange = t4;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = cn("top-sticky-header sticky z-10 bg-white pt-4", baseGridClassName, hideLastItemInGridClassName);
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== handleOnChange || $[11] !== options || $[12] !== values) {
    let t7;
    if ($[14] !== handleOnChange || $[15] !== options) {
      t7 = (value, index_0) => <Select key={index_0} value={value} name={`select-compare-${index_0}`} options={options} placeholder={"\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E23\u0E38\u0E48\u0E19\u0E23\u0E16"} role="cell" onChange={e_0 => handleOnChange(e_0, index_0)} />;
      $[14] = handleOnChange;
      $[15] = options;
      $[16] = t7;
    } else {
      t7 = $[16];
    }
    t6 = values.map(t7);
    $[10] = handleOnChange;
    $[11] = options;
    $[12] = values;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[17] !== t6) {
    t7 = <div role="row" className={t5}>{t6}</div>;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};